import { List } from "@/components/list/List";
import { ReactNode } from "react";

interface ContractorsPlannedHoursWizardListSectionProps {
  children?: ReactNode;
}

export function ContractorsPlannedHoursWizardListSection({
  children = <List.Status />,
}: ContractorsPlannedHoursWizardListSectionProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-1">
      <List.Menubar className="mb-0 min-w-0 w-full shrink-0 justify-start">
        <List.Menubar.Columns />
        <List.Menubar.Reset />
      </List.Menubar>
      <List.Content className="min-h-0 flex-1 flex-col">
        <div className="flex min-h-14 w-full shrink-0 items-center">
          {children}
        </div>
      </List.Content>
    </div>
  );
}
